<label class="radio-wrapper"  [class.disable-btn]="isDisabled">
  <input type="radio"
         [checked]="checked"
         [disabled]="isDisabled"
         [name]="radioGroup.name"
         (change)="change()"
        />
  <span class="radio"
        [class.checked]="checked"></span>
  <span class="text" *ngIf="label"> {{label}}</span>
</label>
